import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'validate.js';

import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import Input from 'dpl/common/design_system/Input';
import Button from 'dpl/common/design_system/Button';
import useForm from 'dpl/shared/form/hooks/useForm';
import { newsletterSignupMutationDefinition } from 'dpl/puppy_search_results/utils/queryDefinitions';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';

export function NewsletterFormSuccess() {
  return (
    <Fragment>
      <h4 className="font-18 md:font-20 lh-title mb4">
        Thanks for subscribing!
      </h4>
      <p className="font-14 md:font-16 o-80">We&apos;ll be in touch soon.</p>
    </Fragment>
  );
}

function FooterNewsletterForm() {
  const [isBlurred, setIsBlurred] = useState(false);

  const { mutateAsync: signUpForNewsletter } = useResourceMutation(
    newsletterSignupMutationDefinition()
  );

  const {
    formState,
    formErrors,
    didSubmissionFail,
    handleFieldChange,
    isSubmitting,
    handleSubmission,
    didSubmissionSucceed
  } = useForm({
    onSubmit: async (formStateForSubmission: any) => {
      return signUpForNewsletter({
        body: {
          user: formStateForSubmission
        }
      });
    },
    mapFormStateToValidationSchema: () => ({
      email: CONSTRAINT_TYPES.EMAIL
    })
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    sendRudderstackEvent(ANALYTICS_EVENTS.LEAD_CAPTURED, {
      view_feature: ANALYTICS_VIEW_FEATURES.NEWSLETTER_SIGNUP,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.FOOTER
    });
    handleSubmission();
  }

  const showError = isBlurred && !isEmpty(formErrors) && formState.email;

  return (
    <div className="FooterNewsletterForm white bg-stone-700">
      {didSubmissionSucceed ? (
        <NewsletterFormSuccess />
      ) : (
        <form onSubmit={handleSubmit}>
          <h6 className="font-18 md:font-20 lh-title mb4">
            (In)box full of puppies
          </h6>
          <div
            className={classnames('ba inline-flex br3 pv2 pr2 w-100', {
              'b--gray-300': !showError && !didSubmissionFail,
              'b--rubber-500': showError || didSubmissionFail
            })}
            style={{ maxWidth: '406px' }}
          >
            <Input
              className="w-100 bg-stone-700 b--none font-16"
              name="email"
              onChange={handleFieldChange}
              type="email"
              value={formState.email || ''}
              placeholder="Enter your email"
              onBlur={() => setIsBlurred(true)}
            />
            <Button
              type="submit"
              variant="tertiary"
              className="font-14 md:font-16 lg:font-16 ph6-md"
              disabled={
                isSubmitting || !isEmpty(formErrors) || !formState.email
              }
            >
              Submit
            </Button>
          </div>
        </form>
      )}
    </div>
  );
}

export default FooterNewsletterForm;
